module.exports = __webpack_public_path__ + "assets/img/main-feature-4.659132bd.png";